export const DATE_FORMAT = "YYYY/MM/DD";
export const DATE_TIME_FORMAT_WITH_SECONDS = "YYYY/MM/DD HH:mm:ss";
export const DATE_TIME_FORMAT = "YYYY/MM/DD HH:mm";
export const ISO_FORMAT = "YYYY-MM-DDTHH:mm:ss[Z]";
export const DATE_NOT_TIMEZONE_FORMAT = "YYYY-MM-DD";
export const MONTH_FORMAT = "MM";
export const YEAR_FORMAT = "YYYY";
export const YEAR_MONTH_STR_FORMAT = "YYYY年MM月";
export const YEAR_MONTH_DAY_STR_FORMAT = "YYYY年MM月DD日";
export const YEAR_MONTH_FORMAT = "YYYY/MM";

export const DATE_DISPLAY_FORMAT = "YYYY / MM / DD";
export const DATE_TIME_DISPLAY_FORMAT = "YYYY / MM / DD  HH:mm";
export const DATE_TIME_DISPLAY_FORMAT_WITH_SECONDS = "YYYY / MM / DD  HH:mm:ss";
export const TIME_DISPLAY_FORMAT = "HH:mm";
export const TIME_DISPLAY_FORMAT_WITH_SECONDS = "HH:mm:ss";
export const YEAR_MONTH_DISPLAY_FORMAT = "YYYY / MM";
